import { Link as RouterLink, useLocation } from 'react-router-dom';
import { Breadcrumbs, Link, Typography } from '@mui/material';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import HomeIcon from '@mui/icons-material/Home';

const Breadcrumb = () => {
  const location = useLocation();
  const pathnames = location.pathname.split('/').filter((x) => x);

  // Route name mapping
  const routeNames = {
    dashboard: 'Dashboard',
    profile: 'Profil',
    documents: 'Belgelerim',
    company: 'Şirket',
    users: 'Kullanıcılar',
    settings: 'Ayarlar'
  };

  return (
    <Breadcrumbs
      separator={<NavigateNextIcon fontSize="small" />}
      aria-label="breadcrumb"
    >
      {/* Home / Dashboard */}
      <Link
        component={RouterLink}
        to="/dashboard"
        underline="hover"
        color="inherit"
        sx={{ display: 'flex', alignItems: 'center' }}
      >
        <HomeIcon sx={{ mr: 0.5 }} fontSize="small" />
        Dashboard
      </Link>

      {/* Dynamic breadcrumb items */}
      {pathnames.map((value, index) => {
        const to = `/${pathnames.slice(0, index + 1).join('/')}`;
        const isLast = index === pathnames.length - 1;
        const label = routeNames[value] || value.charAt(0).toUpperCase() + value.slice(1);

        return isLast ? (
          <Typography key={to} color="text.primary" fontWeight={600}>
            {label}
          </Typography>
        ) : (
          <Link
            key={to}
            component={RouterLink}
            to={to}
            underline="hover"
            color="inherit"
          >
            {label}
          </Link>
        );
      })}
    </Breadcrumbs>
  );
};

export default Breadcrumb;

